import { useEffect, useState } from 'react';

import { post, QuoteRequest } from '@meterup/connect-api';
import { useNavigate, useParams } from 'react-router-dom';

// eslint-disable-next-line import/no-cycle
import { route } from '../../routes';
import { logError } from '../../utils/Log.utils';

function Copy() {
  const navigate = useNavigate();
  const { sid } = useParams<{ sid: string }>();
  const [, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const clone = async () => {
      try {
        setLoading(true);

        const response = await post<QuoteRequest, {}>(`quote-requests/${sid}/copy`, {}, setLoading);

        if (!cancelled && response) {
          navigate(route('submit', { sid: response.sid }));
        }
      } catch (e) {
        if (!cancelled) {
          logError(`Unable to copy ${sid} ${(e as Error).message}`);
          setLoading(false);
        }
      }
    };

    clone();

    return () => {
      cancelled = true;
    };
  }, [sid, navigate]);

  return null;
}

export default Copy;
